module.exports = __webpack_public_path__ + "img/aec53bc.jpg";